import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    LazyAction,
} from 'owa-bundling';
import { onOpenLivePersonaEditor, onLivePersonaEditorInternal } from 'owa-nova-actions';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaNovaLivePersonaEditor" */ './lazyIndex'),
    { name: 'OwaNovaLivePersonaEditor' }
);

registerLazyOrchestrator(onOpenLivePersonaEditor, lazyModule, m => m.openLivePersonaEditor);
registerLazyOrchestrator(onLivePersonaEditorInternal, lazyModule, m => m.livePersonaEditorInternal);

export const LivePersonaEditorAsync: typeof lazyIndex.LivePersonaEditorWrapper =
    createLazyComponent(lazyModule, m => m.LivePersonaEditorWrapper);
export { isLivePersonaEditorEnabled } from './utils/isLivePersonaEditorEnabled';
export const lazyCreateProfileLinkedContact: LazyAction<
    typeof lazyIndex.createProfileLinkedContact,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.createProfileLinkedContact);
